module.exports = __webpack_public_path__ + "static/media/12x12no2.61f79fd5.jpg";